import { IFtlState } from "@/data/redux/ftlSlice";
import { IFleetShip, IFleetShipSelection, IShipWeapon, ShipWeaponFacing } from "@/data/types";

export default class FtlService {
  static calculateListTotal(ships: IFleetShipSelection[]): number {
    return ships.reduce((total, ship) => total + this.getShipCost(ship), 0);
  }

  public static getSelected(state: IFtlState) {
    return state.selectedShipId ? state.ships.find((x) => x.selectionId === state.selectedShipId) : null;
  }

  public static getTurret(ship: IFleetShip): IShipWeapon {
    return {
      id: "Turret",
      name: "Turret",
      facing: ShipWeaponFacing.turret,
      range: ship.range,
      attacks: ship.att,
      str: ship.str,
      special: []
    };
  }

  public static getShipCost(ship: IFleetShipSelection) {
    let fullCost = ship.cost;
    const hasRebelHQ = ship.special.includes("Rebel HQ");

    if (ship.hero) {
      fullCost += hasRebelHQ ? Math.max(0, ship.hero.cost - 5) : ship.hero.cost;
    }
    if (ship.title) {
      fullCost += hasRebelHQ ? Math.max(0, ship.title.cost - 5) : ship.title.cost;
    }
    if (ship.xp) {
      fullCost += Math.floor(ship.xp / 5) * 10;
    }

    return fullCost * (ship.count || 1);
  }

  public static getOccupiedSlotCount(ship: IFleetShipSelection) {
    return (ship.systems?.length || 0) + (ship.weapons?.length || 0);
  }
}
